/*
 *
 * Results constants
 *
 */
export const SET_USER_INPUT = "app/Results/SET_USER_INPUT";
export const RESET_LOADED_PROPS = "app/Results/RESET_LOADED_PROPS";

export const GET_JOBS = "app/Results/GET_JOBS";
export const GET_JOBS_SUCCESS = "app/Results/GET_JOBS_SUCCESS";
export const GET_JOBS_ERROR = "app/Results/GET_JOBS_ERROR";

export const GET_PIPELINES = "app/Results/GET_PIPELINES";
export const GET_PIPELINES_SUCCESS = "app/Results/GET_PIPELINES_SUCCESS";
export const GET_PIPELINES_ERROR = "app/Results/GET_PIPELINES_ERROR";

export const GET_CANDIDATES_BY_STATUS = "app/Results/GET_CANDIDATES_BY_STATUS";
export const GET_CANDIDATES_BY_STATUS_SUCCESS =
  "app/Results/GET_CANDIDATES_BY_STATUS_SUCCESS";
export const GET_ALL_CANDIDATES_BY_STATUS_SUCCESS =
  "app/Results/GET_ALL_CANDIDATES_BY_STATUS_SUCCESS";
export const GET_CANDIDATES_BY_STATUS_ERROR =
  "app/Results/GET_CANDIDATES_BY_STATUS_ERROR";

export const CLEAR_CANDIDATES = "app/Results/CLEAR_CANDIDATES";

export const GET_CANDIDATE_COUNTS = "app/Results/GET_CANDIDATE_COUNTS";
export const GET_CANDIDATE_COUNTS_SUCCESS =
  "app/Results/GET_CANDIDATE_COUNTS_SUCCESS";
export const GET_CANDIDATE_COUNTS_ERROR =
  "app/Results/GET_CANDIDATE_COUNTS_ERROR";

export const MOVE_CANDIDATES = "app/Results/MOVE_CANDIDATES";
export const OPTIMISTIC_MOVE_CANDIDATES =
  "app/Results/OPTIMISTIC_MOVE_CANDIDATES";
export const MOVE_CANDIDATES_SUCCESS = "app/Results/MOVE_CANDIDATES_SUCCESS";
export const MOVE_CANDIDATES_ERROR = "app/Results/MOVE_CANDIDATES_ERROR";

export const GET_CANDIDATE_SUMMARY = "app/Results/GET_CANDIDATE_SUMMARY";
export const GET_CANDIDATE_SUMMARY_SUCCESS =
  "app/Results/GET_CANDIDATE_SUMMARY_SUCCESS";
export const GET_CANDIDATE_SUMMARY_ERROR =
  "app/Results/GET_CANDIDATE_SUMMARY_ERROR";

export const GET_MANAGER_GUIDE_REPORT = "app/Results/GET_MANAGER_GUIDE_REPORT";
export const GET_MANAGER_GUIDE_REPORT_SUCCESS =
  "app/Results/GET_MANAGER_GUIDE_REPORT_SUCCESS";
export const GET_MANAGER_GUIDE_REPORT_ERROR =
  "app/Results/GET_MANAGER_GUIDE_REPORT_ERROR";

export const GET_TEST_REPORT = "app/Results/GET_TEST_REPORT";
export const GET_TEST_REPORT_SUCCESS = "app/Results/GET_TEST_REPORT_SUCCESS";
export const GET_TEST_REPORT_ERROR = "app/Results/GET_TEST_REPORT_ERROR";

export const GET_RESUMES = "app/Results/GET_RESUMES";
export const GET_RESUMES_SUCCESS = "app/Results/GET_RESUMES_SUCCESS";
export const GET_RESUMES_ERROR = "app/Results/GET_RESUMES_ERROR";

export const GET_TIMELINE = "app/Results/GET_TIMELINE";
export const GET_TIMELINE_SUCCESS = "app/Results/GET_TIMELINE_SUCCESS";
export const GET_TIMELINE_ERROR = "app/Results/GET_TIMELINE_ERROR";

export const GET_APPLICATION = "app/Results/GET_APPLICATION";
export const GET_APPLICATION_SUCCESS = "app/Results/GET_APPLICATION_SUCCESS";
export const GET_APPLICATION_ERROR = "app/Results/GET_APPLICATION_ERROR";

export const GET_APPLICATIONS_DATA = "app/Results/GET_APPLICATIONS_DATA";

export const GET_DOCUMENTS = "app/Results/GET_DOCUMENTS";
export const GET_DOCUMENTS_SUCCESS = "app/Results/GET_DOCUMENTS_SUCCESS";
export const GET_DOCUMENTS_ERROR = "app/Results/GET_DOCUMENTS_ERROR";

export const GET_LABELS = "app/Results/GET_LABELS";
export const GET_LABELS_SUCCESS = "app/Results/GET_LABELS_SUCCESS";
export const GET_LABELS_ERROR = "app/Results/GET_LABELS_ERROR";

export const CREATE_LABEL = "app/Results/CREATE_LABEL";
export const CREATE_LABEL_SUCCESS = "app/Results/CREATE_LABEL_SUCCESS";
export const CREATE_LABEL_ERROR = "app/Results/CREATE_LABEL_ERROR";

export const ADD_LABEL = "app/Results/ADD_LABEL";
export const DELETE_ADDED_LABEL = "app/Results/DELETE_ADDED_LABEL";
export const CLEAR_ADDED_LABELS = "app/Results/CLEAR_ADDED_LABELS";

export const LABELS_TO_CANDIDATES = "app/Results/LABELS_TO_CANDIDATES";
export const OPTIMISTIC_LABELS_TO_CANDIDATES =
  "app/Results/OPTIMISTIC_LABELS_TO_CANDIDATES";
export const LABELS_TO_CANDIDATES_SUCCESS =
  "app/Results/LABELS_TO_CANDIDATES_SUCCESS";
export const LABELS_TO_CANDIDATES_ERROR =
  "app/Results/LABELS_TO_CANDIDATES_ERROR";

export const SHARE_RESULTS = "app/Results/SHARE_RESULTS";
export const SHARE_RESULTS_SUCCESS = "app/Results/SHARE_RESULTS_SUCCESS";
export const SHARE_RESULTS_ERROR = "app/Results/SHARE_RESULTS_ERROR";
export const CLOSE_SHARE_RESULTS_CONFIRMATION_MODAL =
  "app/Results/CLOSE_SHARE_RESULTS_CONFIRMATION_MODAL";

export const DOWNLOAD_RESULTS = "app/Results/DOWNLOAD_RESULTS";
export const DOWNLOAD_RESULTS_SUCCESS = "app/Results/DOWNLOAD_RESULTS_SUCCESS";
export const DOWNLOAD_RESULTS_ERROR = "app/Results/DOWNLOAD_RESULTS_ERROR";

export const DOWNLOAD_RESULTS_SINGLE = "app/Results/DOWNLOAD_RESULTS_SINGLE";
export const DOWNLOAD_RESULTS_SINGLE_SUCCESS =
  "app/Results/DOWNLOAD_RESULTS_SINGLE_SUCCESS";
export const DOWNLOAD_RESULTS_SINGLE_ERROR =
  "app/Results/DOWNLOAD_RESULTS_SINGLE_ERROR";

export const EMAIL_CANDIDATES = "app/Results/EMAIL_CANDIDATES";
export const EMAIL_CANDIDATES_SUCCESS = "app/Results/EMAIL_CANDIDATES_SUCCESS";
export const EMAIL_CANDIDATES_ERROR = "app/Results/EMAIL_CANDIDATES_ERROR";

export const LOAD_SAVED_EMAIL_TEMPLATES =
  "app/Results/LOAD_SAVED_EMAIL_TEMPLATES";
export const LOAD_SAVED_EMAIL_TEMPLATES_SUCCESS =
  "app/Results/LOAD_SAVED_EMAIL_TEMPLATES_SUCCESS";
export const LOAD_SAVED_EMAIL_TEMPLATES_ERROR =
  "app/Results/LOAD_SAVED_EMAIL_TEMPLATES_ERROR";

export const RESCHEDULE_TESTS = "app/Results/RESCHEDULE_TESTS";
export const RESCHEDULE_TESTS_SUCCESS = "app/Results/RESCHEDULE_TESTS_SUCCESS";
export const RESCHEDULE_TESTS_ERROR = "app/Results/RESCHEDULE_TESTS_ERROR";
export const RESET_SCHEDULE_STATUS = "app/Scheduling/RESET_SCHEDULE_STATUS";

export const GET_TEST_BATTERIES = "app/Results/GET_TEST_BATTERIES";
export const GET_TEST_BATTERIES_SUCCESS =
  "app/Results/GET_TEST_BATTERIES_SUCCESS";
export const GET_TEST_BATTERIES_ERROR = "app/Results/GET_TEST_BATTERIES_ERROR";

export const GET_TM_SCORERANGES = "app/Results/GET_TM_SCORERANGES";
export const GET_TM_SCORERANGES_SUCCESS =
  "app/Results/GET_TM_SCORERANGES_SUCCESS";
export const GET_TM_SCORERANGES_ERROR = "app/Results/GET_TM_SCORERANGES_ERROR";

export const GET_CANDIDATE_RATINGS = "app/Results/GET_CANDIDATE_RATINGS";
export const GET_CANDIDATE_RATINGS_SUCCESS =
  "app/Results/GET_CANDIDATE_RATINGS_SUCCESS";
export const GET_CANDIDATE_RATINGS_ERROR =
  "app/Results/GET_CANDIDATE_RATINGS_ERROR";

export const RATE_CANDIDATE = "app/Results/RATE_CANDIDATE";
export const RATE_CANDIDATE_SUCCESS = "app/Results/RATE_CANDIDATE_SUCCESS";
export const RATE_CANDIDATE_ERROR = "app/Results/RATE_CANDIDATE_ERROR";

export const EDIT_CANDIDATE_RATING = "app/Results/EDIT_CANDIDATE_RATING";
export const EDIT_CANDIDATE_RATING_SUCCESS =
  "app/Results/EDIT_CANDIDATE_RATING_SUCCESS";
export const EDIT_CANDIDATE_RATING_ERROR =
  "app/Results/EDIT_CANDIDATE_RATING_ERROR";

export const GET_JOB_RATING = "app/Results/GET_JOB_RATING";
export const GET_JOB_RATING_SUCCESS = "app/Results/GET_JOB_RATING_SUCCESS";
export const GET_JOB_RATING_ERROR = "app/Results/GET_JOB_RATING_ERROR";

export const GET_AVG_RATING = "app/Results/GET_AVG_RATING";
export const GET_AVG_RATING_SUCCESS = "app/Results/GET_AVG_RATING_SUCCESS";
export const GET_AVG_RATING_ERROR = "app/Results/GET_AVG_RATING_ERROR";

export const GET_USERS_AND_TEAMS = "app/Results/GET_USERS_AND_TEAMS";
export const GET_USERS_AND_TEAMS_SUCCESS =
  "app/Results/GET_USERS_AND_TEAMS_SUCCESS";
export const GET_USERS_AND_TEAMS_ERROR =
  "app/Results/GET_USERS_AND_TEAMS_ERROR";

export const POST_NOTE = "app/Results/POST_NOTE";
export const POST_NOTE_SUCCESS = "app/Results/POST_NOTE_SUCCESS";
export const POST_NOTE_ERROR = "app/Results/POST_NOTE_ERROR";

export const EDIT_NOTE = "app/Results/EDIT_NOTE";
export const EDIT_NOTE_SUCCESS = "app/Results/EDIT_NOTE_SUCCESS";
export const EDIT_NOTE_ERROR = "app/Results/EDIT_NOTE_ERROR";

export const DELETE_NOTE = "app/Results/DELETE_NOTE";
export const DELETE_NOTE_SUCCESS = "app/Results/DELETE_NOTE_SUCCESS";
export const DELETE_NOTE_ERROR = "app/Results/DELETE_NOTE_ERROR";

export const UPLOAD_RESUME = "app/Results/UPLOAD_RESUME";
export const UPLOAD_RESUME_SUCCESS = "app/Results/UPLOAD_RESUME_SUCCESS";
export const UPLOAD_RESUME_ERROR = "app/Results/UPLOAD_RESUME_ERROR";

export const INVITE_CANDIDATE = "app/Results/INVITE_CANDIDATE";
export const INVITE_CANDIDATE_SUCCESS = "app/Results/INVITE_CANDIDATE_SUCCESS";
export const INVITE_CANDIDATE_ERROR = "app/Results/INVITE_CANDIDATE_ERROR";

export const DELETE_TEST_EVENT = "app/Results/DELETE_TEST_EVENT";
export const DELETE_TEST_EVENT_SUCCESS =
  "app/Results/DELETE_TEST_EVENT_SUCCESS";
export const DELETE_TEST_EVENT_ERROR = "app/Results/DELETE_TEST_EVENT_ERROR";
export const RESET_DELETE_TEST_EVENT_SUCCESS =
  "app/Results/RESET_DELETE_TEST_EVENT_SUCCESS";

export const RELEASE_SCORES = "app/Results/RELEASE_SCORES";
export const RELEASE_SCORES_SUCCESS = "app/Results/RELEASE_SCORES_SUCCESS";
export const RELEASE_SCORES_ERROR = "app/Results/RELEASE_SCORES_ERROR";

export const GET_FILTERS = "app/Results/GET_FILTERS";
export const GET_FILTERS_SUCCESS = "app/Results/GET_FILTERS_SUCCESS";
export const GET_FILTERS_ERROR = "app/Results/GET_FILTERS_ERROR";

export const GET_CHECKR_PACKAGES = "app/Results/GET_CHECKR_PACKAGES";
export const GET_CHECKR_PACKAGES_SUCCESS =
  "app/Results/GET_CHECKR_PACKAGES_SUCCESS";
export const GET_CHECKR_PACKAGES_ERROR =
  "app/Results/GET_CHECKR_PACKAGES_ERROR";

export const CHECKR_INVITE_CANDIDATE = "app/Results/CHECKR_INVITE_CANDIDATE";
export const CHECKR_INVITE_CANDIDATE_SUCCESS =
  "app/Results/CHECKR_INVITE_CANDIDATE_SUCCESS";
export const CHECKR_INVITE_CANDIDATE_ERROR =
  "app/Results/CHECKR_INVITE_CANDIDATE_ERROR";

export const GET_CHECKR_INFO = "app/Results/GET_CHECKR_INFO";
export const GET_CHECKR_INFO_SUCCESS = "app/Results/GET_CHECKR_INFO_SUCCESS";
export const GET_CHECKR_INFO_ERROR = "app/Results/GET_CHECKR_INFO_ERROR";

export const SET_CANDIDATE_FOUND = "app/Results/SET_CANDIDATE_FOUND";

export const LOAD_TESTMAKER_TESTS = "app/Results/LOAD_TESTMAKER_TESTS";
export const LOAD_TESTMAKER_TESTS_SUCCESS =
  "app/Results/LOAD_TESTMAKER_TESTS_SUCCESS";
export const LOAD_TESTMAKER_TESTS_ERROR =
  "app/Results/LOAD_TESTMAKER_TESTS_ERROR";

export const DOWNLOAD_RESUME = "app/Results/DOWNLOAD_RESUME";
export const DOWNLOAD_RESUME_SUCCESS = "app/Results/DOWNLOAD_RESUME_SUCCESS";
export const DOWNLOAD_RESUME_ERROR = "app/Results/DOWNLOAD_RESUME_ERROR";

export const LOAD_SCORE_RANGES = "app/Results/LOAD_SCORE_RANGES";
export const LOAD_SCORE_RANGES_SUCCESS =
  "app/Results/LOAD_SCORE_RANGES_SUCCESS";
export const LOAD_SCORE_RANGES_ERROR = "app/Results/LOAD_SCORE_RANGES_ERROR";

export const MOVE_CANDIDATES_TO_JOB = "app/Results/MOVE_CANDIDATES_TO_JOB";
export const MOVE_CANDIDATES_TO_JOB_SUCCESS =
  "app/Results/MOVE_CANDIDATES_TO_JOB_SUCCESS";
export const MOVE_CANDIDATES_TO_JOB_ERROR =
  "app/Results/MOVE_CANDIDATES_TO_JOB_ERROR";

export const COPY_CANDIDATES_TO_JOB = "app/Results/COPY_CANDIDATES_TO_JOB";
export const COPY_CANDIDATES_TO_JOB_SUCCESS =
  "app/Results/COPY_CANDIDATES_TO_JOB_SUCCESS";
export const COPY_CANDIDATES_TO_JOB_ERROR =
  "app/Results/COPY_CANDIDATES_TO_JOB_ERROR";

export const FLIP_CANDIDATE_PRIVACY = "app/Results/FLIP_CANDIDATE_PRIVACY";
export const FLIP_CANDIDATE_PRIVACY_SUCCESS =
  "app/Results/FLIP_CANDIDATE_PRIVACY_SUCCESS";
export const FLIP_CANDIDATE_PRIVACY_ERROR =
  "app/Results/FLIP_CANDIDATE_PRIVACY_ERROR";

export const GET_PIPELINE_BY_ID = "app/Results/GET_PIPELINE_BY_ID";
export const GET_PIPELINE_BY_ID_SUCCESS =
  "app/Results/GET_PIPELINE_BY_ID_SUCCESS";
export const GET_PIPELINE_BY_ID_ERROR = "app/Results/GET_PIPELINE_BY_ID_ERROR";

export const DELETE_DOCUMENT = "app/Results/DELETE_DOCUMENT";
export const DELETE_DOCUMENT_SUCCESS = "app/Results/DELETE_DOCUMENT_SUCCESS";
export const DELETE_DOCUMENT_ERROR = "app/Results/DELETE_DOCUMENT_ERROR";

export const UPLOAD_DOCUMENT = "app/Results/UPLOAD_DOCUMENT";
export const UPLOAD_DOCUMENT_SUCCESS = "app/Results/UPLOAD_DOCUMENT_SUCCESS";
export const UPLOAD_DOCUMENT_ERROR = "app/Results/UPLOAD_DOCUMENT_ERROR";

export const GET_DOCUMENT_LINK = "app/Results/GET_DOCUMENT_LINK";
export const GET_DOCUMENT_LINK_SUCCESS =
  "app/Results/GET_DOCUMENT_LINK_SUCCESS";
export const GET_DOCUMENT_LINK_ERROR = "app/Results/GET_DOCUMENT_LINK_ERROR";

export const REMIND_CANDIDATE = "app/Results/REMIND_CANDIDATE";
export const REMIND_CANDIDATE_SUCCESS = "app/Results/REMIND_CANDIDATE_SUCCESS";
export const REMIND_CANDIDATE_ERROR = "app/Results/REMIND_CANDIDATE_ERROR";

export const DELETE_INVITATIONS = "app/Results/DELETE_INVITATIONS";
export const DELETE_INVITATIONS_SUCCESS =
  "app/Results/DELETE_INVITATIONS_SUCCESS";
export const DELETE_INVITATIONS_ERROR = "app/Results/DELETE_INVITATIONS_ERROR";

export const GET_WORKPLACE_INSIGHTS = "app/Results/GET_WORKPLACE_INSIGHTS";
export const GET_WORKPLACE_INSIGHTS_SUCCESS =
  "app/Results/GET_WORKPLACE_INSIGHTS_SUCCESS";
export const GET_WORKPLACE_INSIGHTS_ERROR =
  "app/Results/GET_WORKPLACE_INSIGHTS_ERROR";

export const CLEAR_WORKPLACE_INSIGHTS = "app/Results/CLEAR_WORKPLACE_INSIGHTS";

export const GET_MANAGER_GUIDE = "app/Results/GET_MANAGER_GUIDE";
export const GET_MANAGER_GUIDE_SUCCESS =
  "app/Results/GET_MANAGER_GUIDE_SUCCESS";
export const GET_MANAGER_GUIDE_ERROR = "app/Results/GET_MANAGER_GUIDE_ERROR";

export const GET_WORK_STYLES = "app/Results/GET_WORK_STYLES";
export const GET_WORK_STYLES_SUCCESS = "app/Results/GET_WORK_STYLES_SUCCESS";
export const GET_WORK_STYLES_ERROR = "app/Results/GET_WORK_STYLES_ERROR";

export const CLEAR_WORK_STYLES = "app/Results/CLEAR_WORK_STYLES";

export const UPDATE_RESUME_SEARCH_COUNTER =
  "app/Results/UPDATE_RESUME_SEARCH_COUNTER";
export const UPDATE_RESUME_SEARCH_COUNTER_SUCCESS =
  "app/Results/UPDATE_RESUME_SEARCH_COUNTER_SUCCESS";
export const UPDATE_RESUME_SEARCH_COUNTER_ERROR =
  "app/Results/UPDATE_RESUME_SEARCH_COUNTER_ERROR";

export const GET_WORKPLACE_EMAIL_PREVIEW =
  "app/Results/GET_WORKPLACE_EMAIL_PREVIEW";
export const GET_WORKPLACE_EMAIL_PREVIEW_SUCCESS =
  "app/Results/GET_WORKPLACE_EMAIL_PREVIEW_SUCCESS";
export const GET_WORKPLACE_EMAIL_PREVIEW_ERROR =
  "app/Results/GET_WORKPLACE_EMAIL_PREVIEW_ERROR";

export const CLEAR_WORKPLACE_EMAIL_PREVIEW =
  "app/Results/CLEAR_WORKPLACE_EMAIL_PREVIEW";

export const SEND_WORKPLACE_INSIGHTS_EMAIL =
  "app/Results/SEND_WORKPLACE_INSIGHTS_EMAIL";
export const SEND_WORKPLACE_INSIGHTS_EMAIL_SUCCESS =
  "app/Results/SEND_WORKPLACE_INSIGHTS_EMAIL_SUCCESS";
export const SEND_WORKPLACE_INSIGHTS_EMAIL_ERROR =
  "app/Results/SEND_WORKPLACE_INSIGHTS_EMAIL_ERROR";

export const GET_CANDIDATE_BY_ID = "app/Results/GET_CANDIDATE_BY_ID";
export const GET_CANDIDATE_BY_ID_SUCCESS =
  "app/Results/GET_CANDIDATE_BY_ID_SUCCESS";
export const GET_CANDIDATE_BY_ID_ERROR =
  "app/Results/GET_CANDIDATE_BY_ID_ERROR";

export const EDIT_CANDIDATE = "app/Results/EDIT_CANDIDATE";
export const EDIT_CANDIDATE_SUCCESS = "app/Results/EDIT_CANDIDATE_SUCCESS";
export const EDIT_CANDIDATE_ERROR = "app/Results/EDIT_CANDIDATE_ERROR";

export const EXTEND_EVENT_EXPIRATION = "app/Results/EXTEND_EVENT_EXPIRATION";
export const EXTEND_EVENT_EXPIRATION_SUCCESS =
  "app/Results/EXTEND_EVENT_EXPIRATION_SUCCESS";
export const EXTEND_EVENT_EXPIRATION_ERROR =
  "app/Results/EXTEND_EVENT_EXPIRATION_ERROR";

export const RESET_CANDIDATE_SUMMARIES =
  "app/Results/RESET_CANDIDATE_SUMMARIES";

export const UPDATE_CANDIDATES_AFTER_DELETE =
  "app/Results/UPDATE_CANDIDATES_AFTER_DELETE";

export const GET_VIDEO_INTERVIEWS_RESULT =
  "app/Results/GET_VIDEO_INTERVIEWS_RESULT";
export const GET_VIDEO_INTERVIEWS_RESULT_SUCCESS =
  "app/Results/GET_VIDEO_INTERVIEWS_RESULT_SUCCESS";
export const GET_VIDEO_INTERVIEWS_RESULT_ERROR =
  "app/Results/GET_VIDEO_INTERVIEWS_RESULT_ERROR";

export const GET_VIDEO_INTERVIEW_TEMPLATES =
  "app/Results/GET_VIDEO_INTERVIEW_TEMPLATES";
export const GET_VIDEO_INTERVIEW_TEMPLATES_SUCCESS =
  "app/Results/GET_VIDEO_INTERVIEW_TEMPLATES_SUCCESS";
export const GET_VIDEO_INTERVIEW_TEMPLATES_ERROR =
  "app/Results/GET_VIDEO_INTERVIEW_TEMPLATES_ERROR";

export const GET_JOB_BY_ID = "app/Results/GET_JOB_BY_ID";
export const GET_JOB_BY_ID_SUCCESS = "app/Results/GET_JOB_BY_ID_SUCCESS";
export const GET_JOB_BY_ID_ERROR = "app/Results/GET_JOB_BY_ID";

export const RESCHEDULE_VIDEO_INTERVIEW =
  "app/Results/RESCHEDULE_VIDEO_INTERVIEW";
export const RESCHEDULE_VIDEO_INTERVIEW_SUCCESS =
  "app/Results/RESCHEDULE_VIDEO_INTERVIEW_SUCCESS";
export const RESCHEDULE_VIDEO_INTERVIEW_ERROR =
  "app/Results/RESCHEDULE_VIDEO_INTERVIEW_ERROR";

export const CHANGE_SORT_CRITERIA = "app/Results/CHANGE_SORT_CRITERIA";

export const GET_JOB_RESULTS_CUSTOMIZATION =
  "app/Results/GET_JOB_RESULTS_CUSTOMIZATION";
export const GET_JOB_RESULTS_CUSTOMIZATION_SUCCESS =
  "app/Results/GET_JOB_RESULTS_CUSTOMIZATION_SUCCESS";
export const GET_JOB_RESULTS_CUSTOMIZATION_ERROR =
  "app/Results/GET_JOB_RESULTS_CUSTOMIZATION_ERROR";
export const UPDATE_JOB_RESULTS_CUSTOMIZATIONS =
  "app/Results/UPDATE_JOB_RESULTS_CUSTOMIZATIONS";
export const UPDATE_JOB_RESULTS_CUSTOMIZATIONS_SUCCESS =
  "app/Results/UPDATE_JOB_RESULTS_CUSTOMIZATIONS_SUCCESS";
export const UPDATE_JOB_RESULTS_CUSTOMIZATIONS_ERROR =
  "app/Results/UPDATE_JOB_RESULTS_CUSTOMIZATIONS_ERROR";

export const SHOW_RESULTS_V2_BULK_ACTION_MODAL =
  "app/Results/SHOW_RESULTS_V2_BULK_ACTION_MODAL";

export const REVERT_RESULTS_CUSTOMIZATIONS =
  "app/Results/REVERT_RESULTS_CUSTOMIZATIONS";
export const REVERT_RESULTS_CUSTOMIZATIONS_SUCCESS =
  "app/Results/REVERT_RESULTS_CUSTOMIZATIONS_SUCCESS";
export const REVERT_RESULTS_CUSTOMIZATIONS_ERROR =
  "app/Results/REVERT_RESULTS_CUSTOMIZATIONS_ERROR";
export const GET_CANDIDATE_SI_REPORT = "app/Results/GET_CANDIDATE_SI_REPORT";
export const GET_CANDIDATE_SI_REPORT_ERROR =
  "app/Results/GET_CANDIDATE_SI_REPORT_ERROR";

export const SET_CURRENT_STAGE_ID = "app/Results/SET_CURRENT_STAGE_ID";

export const RESET_MOVE_CANDIDATES_STATUS =
  "app/Results/RESET_MOVE_CANDIDATES_STATUS";

export const GET_LIVE_INTERVIEWS_RESULT =
  "app/Results/GET_LIVE_INTERVIEWS_RESULT";
export const GET_LIVE_INTERVIEWS_RESULT_SUCCESS =
  "app/Results/GET_LIVE_INTERVIEWS_RESULT_SUCCESS";
export const GET_LIVE_INTERVIEWS_RESULT_ERROR =
  "app/Results/GET_LIVE_INTERVIEWS_RESULT_ERROR";

export const SEND_EVALUATORS_EMAIL = "app/Results/SEND_EVALUATORS_EMAIL";
export const SEND_EVALUATORS_EMAIL_SUCCESS =
  "app/Results/SEND_EVALUATORS_EMAIL_SUCCESS";
export const SEND_EVALUATORS_EMAIL_ERROR =
  "app/Results/SEND_EVALUATORS_EMAIL_ERROR";

export const RESET_SEND_EVALUATORS_EMAIL_STATUS =
  "app/Results/RESET_SEND_EVALUATORS_EMAIL_STATUS";

export const SEND_INDIVIDUAL_EVALUATOR_EMAIL =
  "app/Results/SEND_INDIVIDUAL_EVALUATOR_EMAIL";
export const SEND_INDIVIDUAL_EVALUATOR_EMAIL_SUCCESS =
  "app/Results/SEND_INDIVIDUAL_EVALUATOR_EMAIL_SUCCESS";
export const SEND_INDIVIDUAL_EVALUATOR_EMAIL_ERROR =
  "app/Results/SEND_INDIVIDUAL_EVALUATOR_EMAIL_ERROR";

export const GET_DYNAMIC_SCORE_REPORTS_DATA =
  "app/Results/GET_DYNAMIC_SCORE_REPORTS_DATA";
export const GET_DYNAMIC_SCORE_REPORTS_DATA_SUCCESS =
  "app/Results/GET_DYNAMIC_SCORE_REPORTS_DATA_SUCCESS";
export const GET_DYNAMIC_SCORE_REPORTS_DATA_ERROR =
  "app/Results/GET_DYNAMIC_SCORE_REPORTS_DATA_ERROR";

export const REMOVE_MERCH_BANNER = "app/Results/REMOVE_MERCH_BANNER";
export const REMOVE_MERCH_BANNER_SUCCESS =
  "app/Results/REMOVE_MERCH_BANNER_SUCCESS";
export const REMOVE_MERCH_BANNER_ERROR =
  "app/Results/REMOVE_MERCH_BANNER_ERROR";

export const MOVE_CANDIDATE_TO_POST_HIRE =
  "app/Results/MOVE_CANDIDATE_TO_POST_HIRE";
export const MOVE_CANDIDATE_TO_POST_HIRE_SUCCESS =
  "app/Results/MOVE_CANDIDATE_TO_POST_HIRE_SUCCESS";
export const MOVE_CANDIDATE_TO_POST_HIRE_ERROR =
  "app/Results/MOVE_CANDIDATE_TO_POST_HIRE_ERROR";
export const RESET_MOVE_CANDIDATE_TO_POST_HIRE_STATUS =
  "app/Results/RESET_MOVE_CANDIDATE_TO_POST_HIRE_STATUS";

export const GET_POST_HIRE_USERS = "app/Results/GET_POST_HIRE_USERS";
export const GET_POST_HIRE_USERS_SUCCESS =
  "app/Results/GET_POST_HIRE_USERS_SUCCESS";
export const GET_POST_HIRE_USERS_ERROR =
  "app/Results/GET_POST_HIRE_USERS_ERROR";
export const CHECK_FOR_VALID_POST_HIRE_EMAIL =
  "app/Results/CHECK_FOR_VALID_POST_HIRE_EMAIL";
export const CHECK_FOR_VALID_POST_HIRE_EMAIL_SUCCESS =
  "app/Results/CHECK_FOR_VALID_POST_HIRE_EMAIL_SUCCESS";
export const CHECK_FOR_VALID_POST_HIRE_EMAIL_ERROR =
  "app/Results/CHECK_FOR_VALID_POST_HIRE_EMAIL_ERROR";
export const GET_POST_HIRE_TEST_TAKERS =
  "app/Results/GET_POST_HIRE_TEST_TAKERS";
export const GET_POST_HIRE_TEST_TAKERS_SUCCESS =
  "app/Results/GET_POST_HIRE_TEST_TAKERS_SUCCESS";
export const GET_POST_HIRE_TEST_TAKERS_ERROR =
  "app/Results/GET_POST_HIRE_TEST_TAKERS_ERROR";

export const EDIT_VIDEO_INTERVIEW_ADJUSTMENTS =
  "app/Results/EDIT_VIDEO_INTERVIEW_ADJUSTMENTS";
export const EDIT_VIDEO_INTERVIEW_ADJUSTMENTS_SUCCESS =
  "app/Results/EDIT_VIDEO_INTERVIEW_ADJUSTMENTS_SUCCESS";
export const EDIT_VIDEO_INTERVIEW_ADJUSTMENTS_ERROR =
  "app/Results/EDIT_VIDEO_INTERVIEW_ADJUSTMENTS_ERROR";

export const GET_ALL_POSTHIRE_TEAMS = "app/Results/GET_ALL_POSTHIRE_TEAMS";
export const GET_ALL_POSTHIRE_TEAMS_SUCCESS =
  "app/Results/GET_ALL_POSTHIRE_TEAMS_SUCCESS";
export const GET_ALL_POSTHIRE_TEAMS_ERROR =
  "app/Results/GET_ALL_POSTHIRE_TEAMS_ERROR";

export const GET_TEAM_PERSONALITY_SCORES_BY_ID =
  "app/Results/GET_TEAM_PERSONALITY_SCORES_BY_ID";
export const GET_TEAM_PERSONALITY_SCORES_BY_ID_SUCCESS =
  "app/Results/GET_TEAM_PERSONALITY_SCORES_BY_ID_SUCCESS";
export const GET_TEAM_PERSONALITY_SCORES_BY_ID_ERROR =
  "app/Results/GET_TEAM_PERSONALITY_SCORES_BY_ID_ERROR";

export const GET_SMART_ONBOARDING_KEY_INSIGHTS =
  "app/Results/GET_SMART_ONBOARDING_KEY_INSIGHTS";
export const GET_SMART_ONBOARDING_KEY_INSIGHTS_SUCCESS =
  "app/Results/GET_SMART_ONBOARDING_KEY_INSIGHTS_SUCCESS";
export const GET_SMART_ONBOARDING_KEY_INSIGHTS_ERROR =
  "app/Results/GET_SMART_ONBOARDING_KEY_INSIGHTS_ERROR";
export const RESET_SMART_ONBOARDING_KEY_INSIGHTS =
  "app/Results/RESET_SMART_ONBOARDING_KEY_INSIGHTS";
export const GET_LANDING_PAGE = "app/Results/GET_LANDING_PAGE";
export const GET_LANDING_PAGE_SUCCESS = "app/Results/GET_LANDING_PAGE_SUCCESS";
export const GET_LANDING_PAGE_ERROR = "app/Results/GET_LANDING_PAGE_ERROR";

export const GET_PROCTORING_REPORT = "app/Results/GET_PROCTORING_REPORT";
export const GET_PROCTORING_REPORT_SUCCESS =
  "app/Results/GET_PROCTORING_REPORT_SUCCESS";
export const GET_PROCTORING_REPORT_ERROR =
  "app/Results/GET_PROCTORING_REPORT_ERROR";

export const UPDATE_DOWNLOAD_STATUS = "app/Results/UPDATE_DOWNLOAD_STATUS";
